import functions from '../../functions';

if ( window.wp && window.wp.ajax ) {
    const { registerBlockType } = window.wp.blocks;
    const { RawHTML } = window.wp.element;

    const { 
        RichText,
        InspectorControls,
    } = window.wp.editor;
    
    const { 
        PanelBody, 
        TextControl,
        SelectControl,
        CheckboxControl
    } = window.wp.components;

    registerBlockType('custom-gutenberg/title-section', {
        // built-in attributes
        title: 'Title section',
        description: 'Title section',
        icon: '',
        category: 'custom-components',
        example: {},

        // custom attributes
        attributes: {
            subtitleTop: {
                type: 'string',
                default: 'Destinations',
            },
            title: {
                type: 'string',
                default: 'Must see around'
            },
            lowerTextTag: {
                type: 'string',
                default: 'div'
            },
        },

        // built-in functions
        edit({ attributes, setAttributes, className }) {

            const {
                subtitleTop,
                title,
                lowerTextTag,
                classes
            } = attributes;

            // custom functions
            function onUpperTextChange (upperText) {
                setAttributes({subtitleTop: upperText});
            };


            function onLowerTextChange(lowerText) {
                setAttributes({title: lowerText});
            }

            className = functions.getClassNames(className);
            if(classes != className) setAttributes({classes: className});

            return ([
                <InspectorControls style={ { marginBottom: '40px' } }>
                    <PanelBody title={ 'Settings' }>
                        <p><strong>Upper text</strong></p>
                        <TextControl value={ subtitleTop } onChange={ onUpperTextChange }></TextControl>


                        <p><strong>Title</strong></p>
                        <TextControl value={ title } onChange={ onLowerTextChange }></TextControl>
                        <p><strong>Title type</strong></p>
                        <SelectControl
                            label="Title type"
                            value={lowerTextTag}
                            options={ [
                                {
                                    value: 'div',
                                    label: 'Div',
                                },
                                {
                                    value: 'h1',
                                    label: 'Heading 1',
                                },
                                {
                                    value: 'h2',
                                    label: 'Heading 2',
                                },
                                {
                                    value: 'h3',
                                    label: 'Heading 3',
                                },
                                {
                                    value: 'h4',
                                    label: 'Heading 4',
                                },
                                {
                                    value: 'h5',
                                    label: 'Heading 5',
                                },
                                {
                                    value: 'h6',
                                    label: 'Heading 6',
                                }
                            ]}
                            onChange={ ( newSize ) => setAttributes({'lowerTextTag': newSize}) }
                        />
                        <br />

                    </PanelBody>
                </InspectorControls>
                ,
                <div class="content-title-section">
                    { subtitleTop && (
                        <div class="d-flex align-items-center gap-3">
                            <img src="/wp-content/uploads/leaf.png" width="25" height="26" class="leaf" />
                            <RichText 
                                    key="editable" 
                                    tagName="div"
                                    className="subtitle-top"
                                    placeholder="Destinations" 
                                    value={ subtitleTop }
                                    onChange={ onUpperTextChange } />
                        </div>
                    )}

                    <RichText 
                        key="editable" 
                        tagName="div"
                        className="title"
                        placeholder="Must see around" 
                        value={ title }
                        onChange={ onLowerTextChange } />
                </div>
            ]);
        },

        save({ attributes }) {

            const {
                subtitleTop,
                title,
                lowerTextTag,
                classes
            } = attributes;

            const LowerTag = `` + lowerTextTag + ``;

            return (
                <div className={"content-title-section "}>
                    { subtitleTop && (
                        <div className="d-flex align-items-center gap-3">
                            <img src="/wp-content/uploads/leaf.png" width="25" height="26" class="leaf" />
                            <div className="subtitle-top">
                                { subtitleTop }
                            </div>
                        </div>
                    )}
                    <LowerTag className="title">
                        { title }
                    </LowerTag>
                </div>
            );
        },
    });
}


